!((document, Drupal, drupalSettings, $, lottie) => {
  'use strict';

  Drupal.behaviors.homeslider = {
    attach: function (context, settings) {

      let slickSlices = $('.homeslider--slices', context);

      if (slickSlices) {
        slickSlices.each(function (key, item) {
            this.id = 'slider__' + key;
            let thisSlick = $('#' + this.id + ':not(.loro-behavior-processed)', context);
            thisSlick.slick({
              infinite: true,
              autoplay: true,
              speed: 300,
              pauseOnHover: false,
              slidesToShow: 1,
              adaptiveHeight: true,
              fade: true,
              cssEase: 'ease',
              dots: true,
              arrows: false
            }).addClass('loro-behavior-processed');

            // Set prev arrow.
            const prevArrow = $(this).find('.prev-arrow:not(.loro-behavior-processed)', context);
            prevArrow.on('click', function () {
              thisSlick.slick('slickPrev');
              prevArrow.addClass('loro-behavior-processed');
            });
            // Set next arrow.
            const nextArrow = $(this).find('.next-arrow:not(.loro-behavior-processed)', context);
            nextArrow.on('click', function () {
              thisSlick.slick('slickNext');
              nextArrow.addClass('loro-behavior-processed');
            });
          }
        );
      }

      let homeslideBgs = $('.homeslide__bg', context);

      if (homeslideBgs) {
        homeslideBgs.each(function (index) {
          const position = (index % 2 === 0) ? 'even' : 'odd';
          $(this).addClass('homeslide__bg--' + position);
        });
      }

      const total = $('.homeslide').length;
      const rand = Math.floor(Math.random() * total);

      function initGamesSlider() {
        let slickGames = $('.homeslider--games:not(.loro-behavior-processed)', context);
        if (slickGames.length) {
          slickGames.slick({
            infinite: true,
            autoplay: true,
            initialSlide: rand,
            autoplaySpeed: 5000,
            speed: 300,
            pauseOnHover: false,
            slidesToShow: 1,
            adaptiveHeight: false,
            fade: true,
            cssEase: 'ease',
            dots: true,
            arrows: false,
          }).addClass('loro-behavior-processed');

          setTimeout(function () {
            slickGames.slick('slickGoTo', 0);
            $('.cloaked', context).addClass('cloaked--uncloaked');
          }, 100);
        }
      }

      initGamesSlider();

      if (lottie && drupalSettings.loro.homeslider.lottie_data_url) {
        const container = document.querySelector('#JouonsResponsable:not(.loro-behavior-processed)');
        if (container) {
          lottie.loadAnimation({
            container,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: drupalSettings.loro.homeslider.lottie_data_url
          });
          container.classList.add('loro-behavior-processed');
        }
      }
    }
  };
})(document, Drupal, drupalSettings, jQuery, lottie);
